<tt-page *ngIf="!!page">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="campaign_keyno" [ttModel]="page.campaign_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="campaign_name" [(ttModel)]="page.campaign_name" ttRequired></tt-input>
        <tt-textarea ttLabel="campaign_description" [(ttModel)]="page.campaign_description"></tt-textarea>
        <tt-datetime ttLabel="campaign_start" [(ttModel)]="page.campaign_start"></tt-datetime>
        <tt-datetime ttLabel="campaign_end" [(ttModel)]="page.campaign_end"></tt-datetime>
        <tt-datetime ttLabel="campaign_registered" [ttModel]="page.campaign_registered" ttReadonly></tt-datetime>
        <tt-select ttLabel="campaign_pricelist_id" [(ttModel)]="page.campaign_pricelist_id" [ttData]="selectListPrices" ttDataId="item_id" ttDataName="item_name" ttRequired></tt-select>
        <tt-button-goto *ngIf="campaignKeyno !== '0'" [ttText]="'campaign_products'" [ttGoto]="'campaignproducts'" [ttGotoParms]="{ campaign_keyno: page.campaign_keyno }"></tt-button-goto>
        <tt-button-save ttText="save_campaign" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
